import { render, staticRenderFns } from "./sourcePapers.vue?vue&type=template&id=b0c4621a&scoped=true&"
import script from "./sourcePapers.vue?vue&type=script&lang=js&"
export * from "./sourcePapers.vue?vue&type=script&lang=js&"
import style0 from "./sourcePapers.vue?vue&type=style&index=0&id=b0c4621a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c4621a",
  null
  
)

export default component.exports